import type { LogoPosition } from "../api/types";
import { DEFAULT_LOGO_POSITION, LOGO_POSITION_JUSTIFY } from "../constants";

/**
 * Resolves `active_config.logo_position` onto a position the header can lay out.
 *
 * The field is absent on notices published before it existed and on responses
 * from an older consent-server, so an unrecognised value is not an error — it
 * simply means "the customer never chose", which is the left-aligned default.
 *
 * Sibling of `resolveColors` in ./colors.ts: same config-then-default shape,
 * kept deliberately parallel with the React package's layout.ts.
 */
export function resolveLogoPosition(raw: string | undefined | null): LogoPosition {
  return raw === "center" || raw === "right" ? raw : DEFAULT_LOGO_POSITION;
}

export function logoRowJustify(position: LogoPosition): string {
  return LOGO_POSITION_JUSTIFY[position];
}
